import React from 'react';
import T from 'prop-types';

const Cursor = ({ audioProgress, pixelsPerSecond }) => (
  <div
    className="editor-timeline__audio-cursor"
    style={{
      left: `${audioProgress * pixelsPerSecond}px`,
    }}
  />
);

Cursor.propTypes = {
  audioProgress: T.number.isRequired,
  pixelsPerSecond: T.number.isRequired,
};

export default Cursor;
